import * as React from "react";
import styled from "styled-components";

const StyledScoreboardPanel = styled.div`
  flex: 1 1 150px;
  display: flex;
  flex-direction: column;
  justify-content: space-evenly;
  height: stretch;
  padding: ${(props) => props.theme.space[2]};
  text-align: center;
  background-color: ${({ theme }) => theme.colors.white8};
  border-radius: 12px;
`;

const Heading = styled.h3`
  margin: 0;
  padding-bottom: ${({ theme }) => theme.space[2]};
  color: ${({ theme }) => theme.colors.white};
  font-size: 1.4rem;
  font-weight: 400;
`;

const Value = styled.div`
  color: ${({ theme }) => theme.colors.white};
  font-size: 2.3rem;
  font-weight: bold;
`;

interface IScoreboardPanel {
  heading: string;
  value: string;
}

type Props = IScoreboardPanel;

export const ScoreboardPanel: React.FC<Props> = ({ heading, value }) => (
  <StyledScoreboardPanel>
    <Heading>{heading}</Heading>
    <Value>{value}</Value>
  </StyledScoreboardPanel>
);
